import React from "react";
import createCanonicalUrl from "../../utils/createCanonicalUrl";
import { SvgLinkList } from "../Svg";

const TWITTER_SHARE = "https://twitter.com/intent/tweet?";
const FB_SHARE = "https://www.facebook.com/sharer/sharer.php?u=";
const LINKEDIN_SHARE = "https://www.linkedin.com/sharing/share-offsite/?url=";

const FbShareLinkGen = ({ url }) => `${FB_SHARE}${url}`;

const TwitterShareLinkGen = ({ url, title, articleAuthorTwitterHandle }) => {
  const encodedLink = `${TWITTER_SHARE}text=${title}&url=${encodeURI(
    url
  )}&via=${articleAuthorTwitterHandle}`;

  return encodeURI(encodedLink);
};

const LinkedinShareLinkGen = ({ url }) => `${LINKEDIN_SHARE}${url}`;

const emailShareLinkGen = ({ url, title }) =>
  `mailto:?subject=${title}&body=${url}`;

const platformsConnector = [
  { name: "FACEBOOK", display: "فيسبوك", linkGen: FbShareLinkGen },
  { name: "TWITTER", display: "تويتر", linkGen: TwitterShareLinkGen },
  { name: "LINKEDIN", display: "لينكد إن", linkGen: LinkedinShareLinkGen },
  { name: "EMAIL", display: "إيميل", linkGen: emailShareLinkGen },
];

const displayPrefix = "شارك عبر";

const SocialShare = ({ slug, title, articleAuthorTwitterHandle }) => {
  const url = createCanonicalUrl(slug);

  const iconLinkConnector = platformsConnector.map(
    ({ name, display, linkGen }) => {
      return {
        name,
        display,
        link: linkGen({ url, title, articleAuthorTwitterHandle }),
      };
    }
  );

  return (
    <div className="absolute -left-50 top-0 h-full">
      <nav className="sticky hidden top-100 lg:block z-10">
        <div className="opacity-75 hover:opacity-100">
          <SvgLinkList
            className="transition duration-300 ease-in-out text-subtle hover:text-brand px-3 py-3 outline-none mb-4 shadow rounded-full"
            isPrimary={false}
            isVertical
            list={iconLinkConnector}
            displayPrefix={displayPrefix}
            target="_blank"
          />
        </div>
      </nav>
    </div>
  );
};

export default SocialShare;
